import * as React from "react";
import { WizardHotelPWAv2Props } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardHotelPWAv2View } from "./WizardHotelPWAv2View";
import { Experiment, isVariantEnabled } from "components/utility/experiment";

@inject("wizardState", "analytics")
@observer
export class WizardHotelPWAv2 extends React.Component<WizardHotelPWAv2Props> {
  constructor(props: WizardHotelPWAv2Props) {
    super(props);

    const hotelWizardState = this.props.wizardState.hotelWizardState;
    const hotelWizardConfig = hotelWizardState.config;
    const isDesktop = Boolean(
      !this.props.context.deviceInformation?.mobile && !this.props.context.deviceInformation?.tablet
    );
    hotelWizardState.overrideConfig(() => {
      hotelWizardConfig.elementId = this.props.flexComponent.id;
      hotelWizardConfig.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle === false ? false : true;
      hotelWizardConfig.heading.title = this.props.flexComponent.model.lobTitle;
      hotelWizardConfig.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      hotelWizardConfig.includeFiltersHotelPWAWizard = this.props.flexComponent.model.includeFiltersHotelPWAWizard;
      hotelWizardConfig.analytics = this.props.analytics;
      hotelWizardConfig.enableMultiplePlaces = this.props.flexComponent.model.enableMultiplePlaces;
      hotelWizardConfig.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
      hotelWizardState.config.heading.lobSubtitleBreakPoint = this.props.flexComponent.model.lobSubtitleBreakPoint;
      hotelWizardConfig.siteIdsWithoutSoftPackages = this.props.flexComponent.model.siteIdsWithoutSoftPackages || [];
      hotelWizardConfig.desktopAutoOpenCalendar = Boolean(
        isDesktop && this.props.flexComponent.model.desktopAutoOpenCalendar
      );

      const currentSiteId = props.context?.site?.id.toString();

      if (
        hotelWizardConfig.siteIdsWithoutSoftPackages.length !== 0 &&
        hotelWizardConfig.siteIdsWithoutSoftPackages.includes(currentSiteId)
      ) {
        hotelWizardConfig.enableAddFlight = false;
        hotelWizardConfig.enableAddCar = false;
      } else {
        hotelWizardConfig.enableAddFlight = this.props.flexComponent.model.enableAddFlight;
        hotelWizardConfig.enableAddCar = this.props.flexComponent.model.enableAddCar;
      }

      let enableEGTA = false;
      if (this.props.context.locale === "en_US") {
        if (this.props.context?.site?.id in ["1", "70201", "70301", "80001"]) {
          enableEGTA = true;
        }
      } else {
        enableEGTA = isVariantEnabled(this.props.context, Experiment.EGTA_BEX_ML_V0);
      }

      hotelWizardState.config.location.destination.essAdapterConfig.egtaExperimentEnabled = enableEGTA;
    });

    hotelWizardState.updateStateFromCookie();
    hotelWizardState.updateDateFromConfig();
  }

  public render() {
    return <WizardHotelPWAv2View {...this.props} />;
  }
}

export default WizardHotelPWAv2;
